import type { AdminLanguage } from '@sirius/contracts/admin'
import { ADMIN_LANGUAGE_NAMES, ADMIN_LANGUAGES } from '@sirius/contracts/admin'

export function isAdminLanguage(value: unknown): value is AdminLanguage {
  return (ADMIN_LANGUAGES as readonly unknown[]).includes(value)
}

/**
 * The options of an admin language `InheritableSelect` (which puts "Use
 * default" first), in the contract's order, each by its own name.
 */
export const ADMIN_LANGUAGE_OPTIONS: readonly {
  value: AdminLanguage
  label: string
}[] = ADMIN_LANGUAGES.map((code) => ({
  value: code,
  label: ADMIN_LANGUAGE_NAMES[code],
}))

/**
 * What a tenant's or the platform's Use default stands for, by name: the
 * language it inherits, or the browser's while nothing above sets one (null).
 * `browser` is its text in the panel language.
 */
export function inheritedAdminLanguageLabel(
  inherited: AdminLanguage | null | undefined,
  browser: string,
): string | undefined {
  if (inherited === undefined) {
    return undefined
  }
  return inherited === null ? browser : ADMIN_LANGUAGE_NAMES[inherited]
}
